// extracted by mini-css-extract-plugin
export default {"root":"InfoBox_root__jukrF","title":"InfoBox_title__H84cG","description":"InfoBox_description__GErK8"};